import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

import { LzLanguageService } from '../../../services/lz-language/lz-language.service';
import { LzCookieService } from "../../../services/lz-cookie/lz-cookie";
import { CustomRequestService } from "../../../services/custom-request/custom-request.service";

import { LzAuthNewComponent } from "../components/lz-auth-new/lz-auth-new.component";
import { LzRegNewComponent } from "../components/lz-reg-new/lz-reg-new.component";
import { LzProductConfig } from "../../../services/product-config/poduct-config";
import { LzWelcomeComponent } from "../components/lz-welcome/lz-welcome.component";
import { LzRemindNewComponent } from "../components/lz-remind-new/lz-remind-new.component";

declare var Fingerprint: any;
declare var platform: any;

@Injectable()
export class LzUserService {

  private lang;
  private fingerprint;

  private userInformation = {};
  private userInformationCallbacks = [];
  private userInfo = {};
  private userInfoCallbacks = [];
  private userProducts = {};
  private userProductsCallbacks = [];

  private config;

  constructor(private language: LzLanguageService,
    private lzCookie: LzCookieService,
    public authDialogRef: MatDialogRef < LzAuthNewComponent > ,
    public regDialogRef: MatDialogRef < LzRegNewComponent > ,
    public remindDialogRef: MatDialogRef < LzRemindNewComponent > ,
    public welcomeDialogRef: MatDialogRef < LzWelcomeComponent > ,
    private lzProductConfig: LzProductConfig,
    public dialog: MatDialog,
    private customRequestService: CustomRequestService) {
    this.lang = this.language.identifyLanguage();
    this.fingerprint = new Fingerprint();
    this.config = lzProductConfig.getProductSettings();
  }

  private localCheck = (callback: any) => {
    this.customRequestService.getRequest('lzservice/authorize/checkjson').toPromise().then(msg => {
      callback(JSON.parse(JSON.stringify(msg)));
    })
  }

  private localCheck2 = (callback: any) => {
    this.customRequestService.getRequest(this.lzProductConfig.getApiLink() + '/lz-platforma/user/v1.0/userInfo').subscribe((msg) => {
      callback(msg);
    });
  }

  private userReload = (callback ? : any) => {
    this.customRequestService.getRequest('lzservice/authorize/reloadUser').toPromise().then(msg => {
      if (callback) {
        callback(JSON.parse(JSON.stringify(msg)));
      }
    })
  }

  private deepEquals = (x: any, y: any) => {
    if (x === y) {
      return true; // if both x and y are null or undefined and exactly the same
    } else if (!(x instanceof Object) || !(y instanceof Object)) {
      return false; // if they are not strictly equal, they both need to be Objects
    } else if (x.constructor !== y.constructor) {
      // they must have the exact same prototype chain, the closest we can do is
      // test their constructor.
      return false;
    } else {
      for (const p in x) {
        if (!x.hasOwnProperty(p)) {
          continue; // other properties were tested using x.constructor === y.constructor
        }
        if (!y.hasOwnProperty(p)) {
          return false; // allows to compare x[ p ] and y[ p ] when set to undefined
        }
        if (x[p] === y[p]) {
          continue; // if they have the same strict value or identity then they are equal
        }
        if (typeof (x[p]) !== 'object') {
          return false; // Numbers, Strings, Functions, Booleans must be strictly equal
        }
        if (!this.deepEquals(x[p], y[p])) {
          return false;
        }
      }
      for (const p in y) {
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
          return false;
        }
      }
      return true;
    }
  }

  private getAllUserProducts = (callback ? : any) => {
    if (this.deepEquals({}, this.userProducts)) {
      if (this.userProductsCallbacks.length != 0) {
        if (callback) this.userProductsCallbacks.push(callback);
        return;
      }
      if (callback) this.userProductsCallbacks.push(callback);
      this.localCheck2((userInformation) => {
        this.convertProductAccessToCorrectObject(userInformation.products, this.callUserCallbacks(this.userProductsCallbacks, this.userProducts));
      });
    } else {
      if (callback) callback(this.userProducts);
    }
  }

  private convertProductAccessToCorrectObject = (products: any, callback: any) => {
    for (let i = 0, length = products.length; i < length; i++) {
      this.userProducts[products[i].extraParams.productAlias] = products[i];
      if (this.userProducts[products[i].extraParams.productAlias].extraParams.resources !== undefined) {
        let modules = this.userProducts[products[i].extraParams.productAlias].extraParams.resources;
        this.userProducts[products[i].extraParams.productAlias].extraParams.modules = {};
        for (let j = 0, mLength = modules.length; j < mLength; j++) {
          this.userProducts[products[i].extraParams.productAlias].extraParams.modules[modules[j].alias] = modules[i]
        }
      }
    }
    if (callback) callback();
  }

  private callUserCallbacks = (callbacks: any, userData: any) => {
    let length = callbacks.length;
    if (callbacks.length == 0) return false;
    for (let i = 0; i < length; i++) {
      callbacks[i](userData);
    }
  }

  private remindPass = (data: any, callback: any) => {
    let oData = {
      language: this.lang,
      email: data.email
    };
    this.customRequestService.getRequest('lzservice/userData/remindPassword', oData).toPromise().then((msg) => {
      callback(JSON.parse(JSON.stringify(msg)));
    });
  }

  private reg = (data: any, callback: any) => {
    let params = {
      'params': {
        'email': data.email ? data.email : '',
        'firstName': data.name ? data.name : '',
        'lastName': data.lastname ? data.lastname : '',
        'phone': data.phone ? data.phone : '',
        'companyName': data.company ? data.company : '',
        'activity': data.activity ? data.activity : '',
        'product_code': "ipas_commercial",
        'utm_source': this.lzCookie.getCookie('utm_sourceHistory') || '',
        'utm_medium': this.lzCookie.getCookie('utm_mediumHistory') || '',
        'utm_campaign': this.lzCookie.getCookie('utm_campaignHistory') || '',
        'dealerId': this.lzCookie.getCookie('dealerIdHistory') || '',
        'partnerCode': this.lzCookie.getCookie('partnerCodeHistory') || ''
      },
      'g-recaptcha-response': data['g-recaptcha-response'] || '',
      'language': this.lang
    }
    this.customRequestService.getRequest('lzservice/userData/registration', params).toPromise().then((msg) => {
      callback(JSON.parse(JSON.stringify(msg)));
    });
  }

  private regQuick(data, callback) {
    let params = {
      'params': {
        'email': data.email ? data.email : '',
        'firstName': data.name ? data.name : '',
        'product_code': data.product_code || "ipas_commercial",
        'utm_source': this.lzCookie.getCookie('utm_sourceHistory') || '',
        'utm_medium': this.lzCookie.getCookie('utm_mediumHistory') || '',
        'utm_campaign': this.lzCookie.getCookie('utm_campaignHistory') || '',
        'dealerId': this.lzCookie.getCookie('dealerIdHistory') || '',
        'partnerCode': this.lzCookie.getCookie('partnerCodeHistory') || ''
      },
      'language': this.lang,
      'g-recaptcha-response': data['g-recaptcha-response'] || ''
    }
    this.customRequestService.getRequest('lzservice/userData/registrationQuick', params).toPromise().then((msg) =>
      callback(JSON.parse(JSON.stringify(msg))),
      (error) => {
        callback(error)
      });
  }

  private auth = (userData: any, callback: any) => {
    let headers = {
      'LigaScreen': this.fingerprint.getScreenResolution().join('X'),
      'LigaBrowser': platform.os.family,
      'LigaOs': platform.name + ' ' + platform.version,
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    };
    let parameters = {
      LigaLogin: userData.email ? userData.email : '',
      LigaPassword: userData.password ? userData.password : ''
    };
    this.customRequestService.postRequestWithFormData(
      this.lzProductConfig.getApiLink() + '/lz-platforma/auth/v2.0/authorize/login',
      parameters,
      undefined,
      headers
    ).toPromise().then((msg) => {
      callback(JSON.parse(JSON.stringify(msg)));
    });
  }

  public showAuthModal = (isSessionOver ? , alias ? ) => {
    console.log("USER SERVICE: get user info");
    this.getUserInfo((msg) => {
      console.log("USER SERVICE: open auth dialog");
      this.authDialogRef = this.dialog.open(LzAuthNewComponent, {
        data: {
          info: msg,
          doAuth: this.auth,
          showReg: this.showRegModal,
          showRemind: this.showRemindModal,
          isSessionOver: (isSessionOver) ? isSessionOver : false,
          alias: (alias) ? alias : ''
        },
        autoFocus: false,
        panelClass: 'myPane'
      });
    })
  }

  public showRegModal = (alias ? ) => {
    this.regDialogRef = this.dialog.open(LzRegNewComponent, {
      data: {
        alias: alias,
        showAuth: this.showAuthModal,
        showWelc: this.showWelcomeModal
      },
      autoFocus: false,
      panelClass: 'myPane'
    });
  };

  public showWelcomeModal = (email, sourceForm) => {
    this.welcomeDialogRef = this.dialog.open(LzWelcomeComponent, {
      data: {
        doAuth: this.auth,
        email: email,
        sourceForm: sourceForm
      },
      panelClass: 'myPane'
    });
  }

  public showRemindModal = (alias ? ) => {
    this.getUserInformation((msg) => {
      this.remindDialogRef = this.dialog.open(LzRemindNewComponent, {
        data: {
          info: msg,
          alias: (alias) ? alias : '',
          showAuth: this.showAuthModal,
          showWelc: this.showWelcomeModal
        },
        panelClass: 'myPane'
      });
    });
  }

  public findConfigurations = (alias: any, conf: any) => {
    return new Promise((resolve, reject) => {
      this.customRequestService.getRequest('lzservice/authorize/checkjson').toPromise().then((message) => {
        let msg = JSON.parse(JSON.stringify(message)).products;
        for (let key in msg) {
          if (msg[key].extraParams && msg[key].extraParams.productAlias && msg[key].extraParams.productAlias == conf && msg[key].extraParams.resources && msg[key].extraParams.resources.length > 0) {
            for (let j = 0; j < msg[key].extraParams.resources.length; j += 1) {
              if (msg[key].extraParams.resources[j].alias == alias) {
                resolve(true);
              }
            }
          }
        }
        resolve(false);
      });
    });
  }

  public getUserInfo = (callback: any) => {
    if (this.deepEquals({}, this.userInfo)) {
      if (this.userInfoCallbacks.length != 0) {
        if (callback) this.userInfoCallbacks.push(callback);
        return;
      }
      if (callback) this.userInfoCallbacks.push(callback);
      this.localCheck2((userInformation) => {
        this.userInfo = userInformation;
        this.callUserCallbacks(this.userInfoCallbacks, this.userInfo);
      });
    } else {
      if (callback) callback(this.userInfo);
    }
  }

  public getUserActualId = (callback: any) => {
    this.customRequestService.getRequest('lzservice/authorize/getUserLigaID').toPromise().then((msg) => {
      callback(JSON.parse(JSON.stringify(msg)));
    });
  }

  public getUserInformation = (callback, isFromServer ? ) => {
    if (this.deepEquals({}, this.userInformation)) {
      if (this.userInformationCallbacks.length != 0) {
        if (callback) this.userInformationCallbacks.push(callback);
        return;
      }
      if (callback) this.userInformationCallbacks.push(callback);
      this.localCheck2((userInf) => {
        this.userInformation = userInf;
        this.callUserCallbacks(this.userInformationCallbacks, this.userInformation);
      });
    } else {
      if (callback) callback(this.userInformation);
    }
  }

  public login = this.auth;

  public registration = this.reg;

  public registrationQuick = this.regQuick;

  public remind = this.remindPass;

  public check = this.localCheck;

  public check2 = this.localCheck2;

  public reloadUser = this.userReload;

  public getUserProducts = this.getAllUserProducts;

}
